import React from 'react';
import luckyIconUrl from '../assets/lucky_icon.svg';

function LuckyIcon({ sizeInPx }) {
    return (
        <div style={{
            height: sizeInPx ? sizeInPx : 50,
            width: sizeInPx ? sizeInPx : 50
        }}>
            <img
                style={{
                    height: 'auto',
                    width: '100%'
                }}
                src={luckyIconUrl}
                alt="Luckynote logo"
            />
        </div>
    );
}

export default LuckyIcon;
